import hosts from './hosts.json'

// Check if hostname is a valid staging domain (app.staging.payhelm.com or app.stagingN.payhelm.com)
const isStagingHost = (hostname: string): boolean => {
    return /^app\.staging\d*\.payhelm\.com$/.test(hostname)
}

export const validateDomain = () => {
    if (!hosts.appHost.whitelist.includes(location.hostname) && !isStagingHost(location.hostname)) {
        console.log('redirecting')
        location.href = location.href.replace(location.hostname, hosts.appHost.default)
        return false
    }
    else return true
}